module.exports = __webpack_public_path__ + "media/integrations/shippy-e0b60643.svg";